export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Food and beverage line operators and technicians, production and shift supervisors, QA and QC staff, food safety teams, sanitation crews, food plant maintenance technicians, people entering the food industry and food science and technology students.',
  ],
  ['Content depth?', 'From food science fundamentals to professional-level processing, sanitation, food safety systems and quality control.'],
  [
    'What format is it?',
    'Professional PDF files with instant access. It is technical reference material — not software, editable templates, ready-to-copy HACCP plans or a course with a certificate. It does not certify anyone.',
  ],
  [
    "Does it replace my site's HACCP plan or procedures?",
    "No. It does not replace your site's approved HACCP / food safety plan, its procedures, the decisions of the food safety and quality team, the legal requirements of each country or the judgment of qualified personnel.",
  ],
  [
    'International?',
    'Yes. Based on internationally used concepts and terminology; always follow local legal requirements, site procedures and the validated values for each product.',
  ],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
